import { graphql } from '@api/generated';

export const GET_VOICEMAIL_FOLLOW_UPS_COUNT_QUERY = graphql(`
  query voicemailsCount($filter: VoicemailFollowUpFilterInput, $take: Int) {
    voicemailFollowUps(filter: $filter, take: $take) {
      totalCount
    }
  }
`);
